import React, { useState } from "react";
import { debugLogin } from "../../firebase/debugLogin";
import { loginUser } from "../../firebase/authService";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [showGuide, setShowGuide] = useState(false);
  const [debugLogs, setDebugLogs] = useState([]);
  const [showDebug, setShowDebug] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setDebugLogs([]);
    setLoading(true);
    setShowDebug(true);

    // Console mein bhi log karo
    console.log("🔐 LOGIN ATTEMPT START");
    console.log("Email:", email);
    console.log("Password length:", password.length);

    try {
      // Step 1: Debug login test
      const debugResult = await debugLogin(email, password);

      // Debug logs set karo
      setDebugLogs(debugResult.logs);

      // Console mein print karo
      debugResult.logs.forEach(log => {
        const prefix = log.status === "success" ? "✅" : log.status === "error" ? "❌" : log.status === "warning" ? "⚠️" : "ℹ️";
        console.log(`${prefix} [${log.step}] ${log.test}: ${log.message}`);
      });

      if (debugResult.success && debugResult.user) {
        console.log("✅ LOGIN SUCCESS:", debugResult.user);
        setSuccess(`✅ Welcome ${debugResult.user.name}! (${debugResult.user.role})`);

        // Normal login use karo (authStateListener handle karega)
        await loginUser(email, password);
        console.log("✅ Normal login also passed");
      } else {
        setError("Login failed! Debug logs check karo.");
      }

    } catch (err) {
      console.error("❌ LOGIN ERROR:", err);
      setError(err.message);
      setDebugLogs([{
        step: 0,
        test: "Unexpected Error",
        status: "error",
        message: err.message
      }]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">

        {/* Logo */}
        <div className="login-logo">
          <div className="logo-icon"><span>SD</span></div>
          <h1>SD<span className="highlight">tech</span> Admin Panel</h1>
          <p>Login to manage your business operations</p>
        </div>

        {/* Login Card */}
        <div className="login-card">

          {error && (
            <div className="login-error">
              <p>❌ {error}</p>
            </div>
          )}

          {success && (
            <div style={{ marginBottom: 16, padding: 12, backgroundColor: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 8 }}>
              <p style={{ color: "#166534", fontSize: 14, fontWeight: 500, margin: 0 }}>{success}</p>
            </div>
          )}

          <form className="login-form" onSubmit={handleLogin}>
            <div className="form-group">
              <label>Email Address</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@sdtech.com"
                required
                autoComplete="email"
              />
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
                autoComplete="current-password"
              />
            </div>

            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? "⏳ Testing & Logging in..." : "🔐 Login to Dashboard"}
            </button>
          </form>

          {/* ========== DEBUG LOGS ========== */}
          {showDebug && debugLogs.length > 0 && (
            <div style={{ marginTop: 16, maxHeight: 400, overflowY: "auto" }}>
              <div style={{
                padding: 12,
                backgroundColor: "#1e293b",
                borderRadius: 8,
                fontFamily: "monospace",
                fontSize: 11,
                lineHeight: 1.8
              }}>
                <div style={{ color: "#94a3b8", marginBottom: 8, fontWeight: 700 }}>
                  🔍 DEBUG LOGS (Login Test Results):
                </div>

                {debugLogs.map((log, i) => (
                  <div key={i} style={{
                    color: log.status === "success" ? "#4ade80" :
                           log.status === "error" ? "#f87171" :
                           log.status === "warning" ? "#fbbf24" : "#94a3b8",
                    padding: "2px 0",
                    borderBottom: "1px solid #334155",
                  }}>
                    <span style={{ color: "#64748b" }}>[Step {log.step}]</span>{" "}
                    <strong>{log.test}:</strong>{" "}
                    <span style={{ whiteSpace: "pre-wrap", wordBreak: "break-all" }}>{log.message}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Toggle Debug View */}
          {debugLogs.length > 0 && (
            <div style={{ marginTop: 8, textAlign: "center" }}>
              <button
                onClick={() => setShowDebug(!showDebug)}
                style={{
                  background: "none", border: "none", cursor: "pointer",
                  color: "#94a3b8", fontSize: 12, textDecoration: "underline"
                }}
              >
                {showDebug ? "Hide Debug Logs" : "Show Debug Logs"}
              </button>
            </div>
          )}

          {/* Troubleshooting Guide */}
          <div style={{ marginTop: 16, textAlign: "center" }}>
            <button
              onClick={() => setShowGuide(!showGuide)}
              style={{
                background: "none", border: "none", cursor: "pointer",
                color: "#2563eb", fontSize: 13, textDecoration: "underline"
              }}
            >
              {showGuide ? "Hide Guide" : "Login nahi ho raha? Guide dekho →"}
            </button>
          </div>

          {showGuide && (
            <div style={{
              marginTop: 16, padding: 16,
              backgroundColor: "#fefce8",
              border: "1px solid #fde047",
              borderRadius: 8,
              fontSize: 12,
              lineHeight: 2.2
            }}>
              <h4 style={{ margin: "0 0 8px", color: "#854d0e", fontSize: 14 }}>
                🔧 Fix Login Issue - Step by Step:
              </h4>

              <div style={{ backgroundColor: "#fffbeb", padding: 12, borderRadius: 6, marginBottom: 12 }}>
                <strong>Step 1:</strong> Firebase Console kholo →{" "}
                <code style={{ background: "#e0e7ff", padding: "2px 6px", borderRadius: 4 }}>console.firebase.com</code>
                <br />
                Apna project select karo
              </div>

              <div style={{ backgroundColor: "#fffbeb", padding: 12, borderRadius: 6, marginBottom: 12 }}>
                <strong>Step 2:</strong> LEFT SIDEBAR → "Authentication"
                <br />
                → "Sign-in method" tab → <strong>"Email/Password"</strong> click karo
                <br />
                → Toggle: <strong>OFF → ON (Enable)</strong>
                <br />
                → "Save" button click karo ✅
                <br />
                <em style={{ color: "#b45309" }}>Agar ye nahi kiya toh login NAHI hoga!</em>
              </div>

              <div style={{ backgroundColor: "#fffbeb", padding: 12, borderRadius: 6, marginBottom: 12 }}>
                <strong>Step 3:</strong> Authentication → "Users" tab
                <br />
                → Top right: <strong>"Add user"</strong> button click karo
                <br />
                → Email: <code style={{ background: "#e0e7ff", padding: "2px 6px", borderRadius: 4 }}>{email || "employee@sdtech.com"}</code>
                <br />
                → Password: <code style={{ background: "#e0e7ff", padding: "2px 6px", borderRadius: 4 }}>{password || "employee123"}</code>
                <br />
                → "Add user" click karo ✅
                <br />
                <em style={{ color: "#b45309" }}>Email EXACTLY match hona chahiye login wali se!</em>
              </div>

              <div style={{ backgroundColor: "#fffbeb", padding: 12, borderRadius: 6, marginBottom: 12 }}>
                <strong>Step 4:</strong> LEFT SIDEBAR → "Firestore Database"
                <br />
                → "Rules" tab → Purana rules hatao
                <br />
                → Ye paste karo:
                <pre style={{
                  backgroundColor: "#1e293b", color: "#e2e8f0",
                  padding: 10, borderRadius: 6, fontSize: 10, marginTop: 6, overflow: "auto"
                }}>
{`rules_version = '2';
service cloud.firestore {
  match /databases/{database}/documents {
    match /{collection}/{doc} {
      allow read, write: if request.auth != null;
    }
  }
}`}
                </pre>
                → <strong>"Publish"</strong> button click karo ✅
              </div>

              <div style={{ backgroundColor: "#fffbeb", padding: 12, borderRadius: 6 }}>
                <strong>Step 5:</strong> Yehi page hard refresh karo
                <br />
                <kbd style={{ background: "#e5e7eb", padding: "2px 8px", borderRadius: 4 }}>Ctrl</kbd> +{" "}
                <kbd style={{ background: "#e5e7eb", padding: "2px 8px", borderRadius: 4 }}>Shift</kbd> +{" "}
                <kbd style={{ background: "#e5e7eb", padding: "2px 8px", borderRadius: 4 }}>R</kbd>
                <br />
                → Fir login try karo ✅
              </div>
            </div>
          )}

          <div className="login-copyright">
            © 2026 SDtech Solutions. All Rights Reserved.
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;